export enum PARTNER_STATUS {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
}

export interface Partner {
  id: string;
  slug: string;
  display_name: string;
  tenant_id: string;
  tenant_slug: string;
  logo?: string;
  status: PARTNER_STATUS;
  created_at: string;
  updated_at: string;
}
